










































































































import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import AMSTooltip from '../../../components/AMSTooltip.vue';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import Utils from '@/utils/utils';
import { allRole } from '@/api/staff';
interface staffDto {
  IsActive?: boolean | undefined;
  Filter?: string | undefined;
  remark?: string | undefined;
  name?: string | undefined;
  phone?: string | undefined;
  roleId?: string | undefined;
  dataPermission?: string | undefined;
}
@Component({
  components: {
    'ams-tooltip': AMSTooltip,
    'ams-breadcrumb': AMSBreadcrumb
  }
})
export default class AddStaff extends Vue {
  $refs!: { form: HTMLFormElement };
  valid: boolean = true;
  name: string = '';
  remark: string = '';
  phone: string = '';
  roleId: string = '';
  dataPermission: string = '';
  addApi: string = '/api/Staff';
  type!: string | (string | null)[];
  items: any = [];
  roleList = [];
  staffId!: string | (string | null)[] | undefined; //员工id
  phoneOk: boolean = false; //手机号验证通过
  isAdmin!: string | (string | null)[] | undefined;
  staffDto: staffDto[] = [];
  addloading: Boolean = false;
  get phoneFormValidate() {
    return;
  }

  get phoneRules() {
    if (this.phoneOk) {
      return ['该手机号码已存在'];
    } else {
      return [(v: string) => !!v || '手机号不能为空', (v: string) => /^1[3-9][0-9]{9}$/.test(v) || '请输入正确的手机号格式'];
    }
  }

  created() {
    this.type = this.$route.query.type;
    this.items = [
      {
        text: '系统设置',
        disabled: false,
        href: '/staffCount'
      },
      {
        text: '员工账号',
        disabled: false,
        href: '/staffCount'
      },
      {
        text: this.type ? '修改账号' : '新增账号',
        disabled: true
      }
    ];
    if (this.type) {
      this.staffId = this.$route.query.id;
      this.isAdmin = this.$route.query.isAdmin;
      this.editInit(this.staffId);
    }
    this.getRoleList();
  }
  changeName(value: string) {
    this.name = value.replace(/\s+/g, '');
  }
  editInit(id: string | (string | null)[] | undefined) {
    request.get(`/api/Staff/${id}`, null).then((data: any) => {
      this.phone = data.phone;
      this.name = data.name;
      this.remark = data.remark;
      this.roleId = data.roleId;
      this.dataPermission = data.dataPermission;
    });
  }
  changePhoneNumber(value: string) {
    request.get('/api/Staff/checkPhoneUsed', { phone: value, staffId: this.staffId }).then(
      (data) => {
        if (data) {
          this.phoneOk = true;
        } else {
          this.phoneOk = false;
        }
        return this.phoneOk;
      },
      () => {}
    );
  }
  getRoleList() {
    allRole().then((data:any) => {
      this.roleList = data.items;
    });
  }
  save() {
    this.$refs.form.validate();
    if (this.$refs.form.validate() && !this.phoneOk) {
      this.addloading = true;
      if (!this.type) {
        let form = {
          name: this.name!.replace(/\s+/g, ''),
          remark: this.remark,
          phone: this.phone,
          roleId: this.roleId,
          dataPermission: this.dataPermission
        };
        let formData = Object.assign({}, form);
        request
          .post(this.addApi, formData)
          .then(() => {
            this.addloading = false;
            AppStore.ShowSuccess('保存成功！');
            this.$router.push('/staffCount');
            Utils.clearAllSearchPage(this.$route.name as string);
          })
          .catch(() => {
            this.addloading = false;
            AppStore.ShowError(`保存失败！`);
            Utils.clearAllSearchPage(this.$route.name as string);
          });
      } else {
        let form = {
          id: this.$route.query.id,
          name: this.name,
          remark: this.remark,
          phone: this.phone,
          roleId: this.roleId,
          dataPermission: this.dataPermission
        };
        let formData = Object.assign({}, form);
        request
          .put(this.addApi, formData)
          .then(() => {
            this.addloading = false;
            AppStore.ShowSuccess('保存成功！');
            this.$router.push('/staffCount');
            Utils.clearAllSearchPage(this.$route.name as string);
          })
          .catch(() => {
            this.addloading = false;
            // AppStore.ShowError(`保存失败！${error.response.data.error.message}`);
            AppStore.ShowError(`保存失败！`);
            Utils.clearAllSearchPage(this.$route.name as string);
          });
      }
    }
  }
  goBack() {
    this.$router.push({
      name: 'staffCount'
    });
  }
}
